import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "./styles.css";
function HeadlessLoading() {
    return (_jsxs("div", { className: "wrapper", children: [_jsx("div", { className: "comment break animate w80" }), _jsx("div", { className: "comment break animate" }), _jsx("div", { className: "comment break animate" })] }));
}
function JustLinesLoading() {
    return (_jsxs("div", { className: "wrapper", children: [_jsx("div", { className: "comment break animate mb20" }), _jsx("div", { className: "comment break animate mb20" }), _jsx("div", { className: "comment break animate mb20" })] }));
}
function RegularLoading() {
    return (_jsxs("div", { className: "wrapper", children: [_jsx("div", { className: "profilePic animate din" }), _jsx("div", { className: "comment break animate w80" }), _jsx("div", { className: "comment break animate" }), _jsx("div", { className: "comment break animate" })] }));
}
function SquareLoading() {
    return (_jsx("div", { className: "wrapperFull", style: { width: "100%" }, children: _jsx("div", { className: "square animate" }) }));
}
function LineItemLoading() {
    return (_jsxs("div", { className: "wrapper fully-spaced-row", style: { marginBottom: "20px" }, children: [_jsx("div", { className: "small-square animate" }), _jsxs("div", { className: "wrapper", style: { paddingLeft: "20px" }, children: [_jsx("div", { className: "comment break animate w80" }), _jsx("div", { className: "comment break animate" }), _jsx("div", { className: "comment break animate" })] })] }));
}
function LoadingLine() {
    return (_jsx("div", { className: "wrapper", children: _jsx("div", { className: "comment break animate" }) }));
}
function Loading(props) {
    if (props.isJustLines) {
        return _jsx(JustLinesLoading, {});
    }
    if (props.isSquare) {
        return _jsx(SquareLoading, {});
    }
    if (props.isLineItems) {
        return _jsx(LineItemLoading, {});
    }
    if (props.hasHead) {
        return _jsx(RegularLoading, {});
    }
    if (props.isLine) {
        return _jsx(LoadingLine, {});
    }
    return _jsx(HeadlessLoading, {});
}
export default Loading;
